export default __webpack_public_path__ + "stroke-width-1.asset.4672a747b28ea2139105ffe0fe338a84.svg";